// extracted by mini-css-extract-plugin
export default {"heading":"PaymentMethodLimits_heading__g0d8o","row":"PaymentMethodLimits_row__WcggM","label":"PaymentMethodLimits_label__ntESN","value":"PaymentMethodLimits_value__dRz0O"};